import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService, CatalogService } from 'src/app/_services';

declare const $ : any;

@Component({
  selector: 'app-modal-info-axa2',
  templateUrl: './modal-info-axa2.component.html',
  styleUrls: ['./modal-info-axa2.component.css']
})
export class ModalInfoAXA2Component implements OnInit {

  
  constructor(
    private translate : TranslateService,
    private auth : AuthenticationService,
    private router : Router,
    private catalogSrv: CatalogService,
  ) { }


  ngOnInit() {
   
  }

  loginStd() {
    this.catalogSrv.clearCache();
    this.auth.relogin().subscribe();
  }



}
